import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";

// import Img from "@assets/img";

import * as S from "./style";
import { API_END_POINTS } from "@utils/EndPoint";
import DashboardConstant from "@views/Pages/Dashboard/landing-image.constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

export interface SideBarProps {
  sideData?: any;
  otherSideData?: any;
}
export interface SideBar {
  id: number;
  title: string;
  link: string;
  logo: string;
  otherAction?: () => void;
  hasDropdown?: boolean;
  dropdownItems?: SideBar[];
}

const robotImages: Record<string, string> = {
  dabur: DashboardConstant.DaburWhite,
  secondary: DashboardConstant.Robot,
  underArmor: DashboardConstant.LoginRobot,
  // Add more themes as needed
  default: DashboardConstant.WnnrLogo,
};

const MAX_TITLE_WIDTH = 138;

const SideBar = ({ sideData, otherSideData }: SideBarProps) => {

  return (
    <S.Wrapper>
      <S.Container>
        {/* <ThemeLogoFromCssVar alt="Logo" style={{ width: 140 }} /> */}
        {sideData?.map((element: SideBar) => {
          return (
            <React.Fragment key={element.id}>
              <SideBarItem element={element} />
            </React.Fragment>
          );
        })}
      </S.Container>
      <S.Container>
        {otherSideData?.map((element: SideBar) => {
          return (
            <React.Fragment key={element.id}>
              <SideBarItem element={element} />
            </React.Fragment>
          );
        })}
      </S.Container>
    </S.Wrapper>
  );
};

const SideBarItem = ({ element }: { element: SideBar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [itemTitleWidth, setItemTitleWidth] = useState<number>();
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const itemTitleRef = useRef<HTMLParagraphElement>(null);

  const currentLink = "/" + location.pathname.split("/")[1];
  const tooltipId = `tooltip-${element.id}`;

  const handleClickAction = () => {
    if (element.hasDropdown) {
      setIsDropdownOpen(!isDropdownOpen);
      return;
    }
    if (element.otherAction) return element.otherAction();
    navigate(element.link);
  };

  const handleDropdownItemClick = (dropdownItem: SideBar) => {
    if (dropdownItem.otherAction) return dropdownItem.otherAction();
    navigate(dropdownItem.link);
  };

  useEffect(() => {
    if (!itemTitleRef?.current?.offsetWidth) return;
    setItemTitleWidth(itemTitleRef.current.offsetWidth);
  }, []);

  // Check if any dropdown item is active
  const isDropdownActive = element.dropdownItems?.some(
    (item) => location.pathname === item.link
  );

  const isActive = currentLink === element.link || isDropdownActive;
  const shouldShowTooltip = element.title.length > 15;

  // Auto-open dropdown if any dropdown item is active
  useEffect(() => {
    if (element.hasDropdown && isDropdownActive) {
      setIsDropdownOpen(true);
    }
  }, [element.hasDropdown, isDropdownActive]);

  // Auto-open dropdown if any dropdown item is active
  useEffect(() => {
    if (element.hasDropdown && isDropdownActive) {
      setIsDropdownOpen(true);
    }
  }, [element.hasDropdown, isDropdownActive]);

  return (
    <>
      <S.SideContent
        key={element.id}
        className={isActive ? "active" : "non-active"}
        onClick={() => handleClickAction()}
      >
        <div className="box-contain">
          {typeof element.logo !== "string" && (
            <FontAwesomeIcon icon={element.logo} className="icon" />
          )}
        </div>
        <p
          ref={itemTitleRef}
          className="title"
          id={shouldShowTooltip ? tooltipId : undefined}
        >
          {element.title}
        </p>
        {element.hasDropdown && (
          <FontAwesomeIcon
            icon={isDropdownOpen ? faChevronUp : faChevronDown}
            className="dropdown-icon"
          />
        )}
        {/* {itemTitleWidth && itemTitleWidth > MAX_TITLE_WIDTH && shouldShowTooltip && (
          <UncontrolledTooltip delay={0} placement="right" target={tooltipId}>
            {element.title}
          </UncontrolledTooltip>
        )} */}
      </S.SideContent>

      {element.hasDropdown && isDropdownOpen && element.dropdownItems && element.dropdownItems.length > 0 && (
        <S.DropdownContainer>
          {element.dropdownItems.map((dropdownItem) => (
            <S.DropdownItem
              key={dropdownItem.id}
              className={
                location.pathname === dropdownItem.link
                  ? "active"
                  : "non-active"
              }
              onClick={() => handleDropdownItemClick(dropdownItem)}
            >
              <div className="box-contain">
                {typeof dropdownItem.logo !== "string" && (
                  <FontAwesomeIcon icon={dropdownItem.logo} className="icon" />
                )}
              </div>
              <p className="title">{dropdownItem.title}</p>
            </S.DropdownItem>
          ))}
        </S.DropdownContainer>
      )}
    </>
  );
};

export default SideBar;
